/**
 * @author Ariel
 * @desc 栏目应用表单页面
 * @date 2020-08-28
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm, WizAuthority } from '../../../common'
import { formatAuth } from '@/utils/commonUtils'

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils, WizOssUpload } = framework_tool
let { WizCard, WizSpin, WizForm, Wizmessage, WizUpload, WizButton,WizTooltip,WizIcon } = component_tool
let { Session } = utils_tool

const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 4, state: 1 } })
const applicationConfig = WizTableForm.Config.applicationInfo(this, { apiParams: { status: 1 } })
const roleConfig = WizTableForm.Config.roleInfo()

class ApplicationColumnDetail extends WizContainer {
  componentName = 'applicationColumnDetail'

  constructor(props) {
    super(props)
    const { history } = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/application/applicationColumn/applicationColumnDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('applicationColumnInfo', initialValue)
      } else {
        initialValue = Session.get('applicationColumnInfo') || {}
      }
      cardTitle = '编辑'
    }
    this.initialValue = initialValue
    this.state = {
      cardTitle,
      applicationId:initialValue.id,
    }
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/application/applicationColumn/applicationColumnDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('applicationColumnInfo', initialValue)
      } else {
        initialValue = Session.get('applicationColumnInfo') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({applicationId:initialValue.id})
      console.log(initialValue,'initialValue22')
    }
  }

  _componentDidMount() {
  }

  propsAndStateOnChange = {
    addApplicationColumn: this._addApplicationColumnOver.bind(this)
  }

  _addApplicationColumnOver(nextProps, nextState) {
    if (nextProps.addApplicationColumn.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/application/applicationColumn');
    } else {
      wizNotice.error('提交失败：' + nextProps.addApplicationColumn.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    fitterValues['img'] = '';
    let columnImg = fitterValues['columnImg']
    if (columnImg && columnImg.length) {
      if (columnImg.length > 1) {
        wizNotice.error('请选择一张封面')
        return false;
      } else {
        columnImg.forEach((value) => {
          fitterValues['img'] = value['fileId']
        })
      }
    }
    delete fitterValues['columnImg']

    // let wechatImg = fitterValues['wechatImg']
    // if (wechatImg && wechatImg.length) {
    //   if (wechatImg.length > 1) {
    //     wizNotice.error('请选择一张企业微信封面')
    //     return false;
    //   } else {
    //     wechatImg.forEach((value) => {
    //       fitterValues['wechatImg'] = value['fileId']
    //     })
    //   }
    // }else if(fitterValues['adapters'].indexOf(4) >-1){
    //   wizNotice.error('请选择一张企业微信封面')
    //   return false;
    // }else {
    //   fitterValues['wechatImg'] = null
    // }

    /**
     * 权限参数处理
     */
    // let authCmd = {}
    // if (fitterValues['authCmd']) {
    //   let authInfo = fitterValues['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // fitterValues['authCmd'] = authCmd

    fitterValues.authCmd = formatAuth(fitterValues.authCmd)

    return fitterValues;
  }


  _addApplicationColumn(values) {
    const { history } = this.props
    let apiPath = 'applicationColumn/add';
    if (history.location && history.location.pathname === '/application/applicationColumn/applicationColumnDetailUpd') {
      apiPath = 'applicationColumn/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    if(fitterValues){
      this.doAction({
        path: apiPath,
        payload: {
          key: 'addApplicationColumn',
          apiParams: { ...fitterValues }
        }
      })
    }
  }

  _render() {
    const { applicationColumnLoading } = this.props
    const { cardTitle } = this.state
    let initialValue = this.initialValue
    let { adapters, roleIds } = initialValue
    let roleIdList = roleIds && roleIds.split(",").length ? roleIds.split(",") : []
    let adapterList = adapters && adapters.split(",").length ? adapters.split(",").map(e => parseInt(e)) : [0, 1]
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.id
        }
      },
      {
        title: '应用名称',
        name: 'name',
        formItem: {
          maxLength: 20,
          placeholder: '应用名称最多输入20个字',
          initialValue: initialValue.name,
          rules: [
            {
              required: true,
              message: '请输入应用名称'
            },
            {
              pattern: /^[\u4e00-\u9fa5a-zA-z0-9\.\-\[\]_·\(\)\/]*$/,
              message: '应用名称只能包含中文、英文、数字、(、)、/、[、]、-、_、.、·'
            }
          ],
        }
      },
      {
        title: '所属服务',
        name: 'applicationId',
        formItem: {
          ...applicationConfig,
          diy: WizTableForm,
          initialValue: initialValue.applicationId,
          initRows: [{
            ...initialValue,
            id: initialValue.applicationId,
            name: initialValue.applicationName
          }],
          selectType: 'radio',
          rules: [
            {
              required: true,
              message: '请选择所属服务'
            }
          ]
        }
      },
      {
        title:  <span>
        封面&nbsp;
        <WizTooltip title="请上传大小不超过200KB,图片尺寸建议800*800">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('columnImg', {
                  rules: [
                    {
                      required: true,
                      message: '请上传封面'
                    }
                  ],
                  initialValue: (initialValue && initialValue.img) ? [
                    { fileId: initialValue.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png '}
                    listType={'picture-card'}
                    aspectRatio={1 / 1}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.195;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过200k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      // {
      //   title: '企业微信封面',
      //   formItem: {
      //     type: 'custom',
      //     render: (record, form) => {
      //       const { getFieldDecorator } = form
      //       return (
      //         <>
      //           {getFieldDecorator('wechatImg', {
      //             // rules: [
      //             //   {
      //             //     required: true,
      //             //     message: '请上传封面'
      //             //   }
      //             // ],
      //             initialValue: (initialValue && initialValue.wechatImg) ? [
      //               { fileId: initialValue.wechatImg }
      //             ] : [],
      //           })(
      //             <WizAvatarUpload
      //             accept={'.jpg, .jpeg, .png '}
      //               listType={'picture-card'}
      //               aspectRatio={1 / 1}
      //               beforeUpload={(file) => {
      //                 const isLt1M = file.size / 1024 / 1024 < 0.195;
      //                 if (!isLt1M) {
      //                   Wizmessage.error('图片不得超过200k!');
      //                 }
      //                 return isLt1M;
      //               }}
      //             />
      //           )}
      //         </>
      //       )
      //     }
      //   },
      // },
      {
        title: '简介',
        name: 'intro',
        formItem: {
          maxLength: 200,
          placeholder: '备注最多输入200个字',
          type: 'textarea',
          initialValue: initialValue.intro
        }
      },
      {
        title: '适用终端',
        name: 'adapters',
        formItem: {
          initialValue: adapterList,
          type: 'checkbox',
          rules: [
            {
              required: true,
              message: '请选择适用终端'
            },
            {
              validator: (rule, value, callback) => {
                this.adapters = value
                callback()
              }
            }
          ]
        },
        dict: [
          { code: 0, codeName: 'PC', },
          { code: 1, codeName: 'APP' },
          // {code: 2, codeName: '企业号'},
        ]
      },
      {
        title: 'URL(PC)',
        name: 'url',
        formItem: {
          initialValue: initialValue.url,
          rules: [
            {
              validator: (rule, value, callback) => {
                let reg = new RegExp(/(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/)
                if (this.adapters && this.adapters.indexOf(0) !== -1) {
                  if (!value || value === '') {
                    callback('选择适用终端PC时URL(PC)不能为空')
                  }
                }
                if (value && value !== '' && !reg.test(value)) {
                  callback('请输入正确格式的URL')
                }
                callback();
              }
            }
          ]
        }
      },
      {
        title: 'URL(APP)',
        name: 'appUrl',
        formItem: {
          initialValue: initialValue.appUrl,
          rules: [
            {
              validator: (rule, value, callback) => {
                if (this.adapters && this.adapters.indexOf(1) !== -1) {
                  if (!value || value === '') {
                    callback('选择适用终端APP时URL(APP)不能为空')
                  }
                }
                callback();
              }
            }
          ]
        }
      },
      // {
      //   title: 'URL(企业微信)',
      //   name: 'busWxUrl',
      //   formItem: {
      //     initialValue: initialValue.busWxUrl,
      //     rules: [
      //       {
      //         validator: (rule, value, callback) => {
      //           if (this.adapters && this.adapters.indexOf(4) !== -1) {
      //             if (!value || value === '') {
      //               callback('选择适用终端企业微信时URL(企业微信)不能为空')
      //             }
      //           }
      //           callback();
      //         }
      //       }
      //     ]
      //   }
      // },
      {
        title: '分类',
        name: 'categoryId',
        formItem: {
          ...categoryConfig,
          diy: WizTableForm,
          initialValue: initialValue.categoryId,
          initRows: [{ ...initialValue, id: initialValue.categoryId, name: initialValue.categoryName }],
          selectType: 'radio',
          rules: [
            {
              required: true,
              message: '请选择分类'
            }
          ]
        }
      },
      {
        title: '类型',
        name: 'type',
        formItem: {
          initialValue: initialValue.type,
          type: 'select',
          dict: [
            { code: 0, codeName: '独立应用' },
            { code: 1, codeName: '内嵌应用' },
            { code: 2, codeName: '外链' },
          ],
          rules: [
            {
              required: true,
              message: '请选择类型'
            }
          ]
        }
      },
      {
        title: '受众',
        name: 'authCmd',
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          mode: 'Form',
          initialValue: initialValue.authInfo,
          record: {
            authCmd: initialValue.authInfo && initialValue.authInfo
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']
        }
      },
      {
        title: '角色',
        name: 'roleIds',
        formItem: {
          ...roleConfig,
          diy: WizTableForm,
          initialValue: roleIdList,
          initRows: initialValue.roleInfos ? initialValue.roleInfos : [],
          selectType: 'checkbox',
        }
      },
      {
        title: '状态',
        name: 'status',
        formItem: {
          initialValue: initialValue.status != null ? initialValue.status : 1,
          type: 'radio'
        },
        dict: [
          { code: 1, codeName: '启用' },
          { code: 0, codeName: '禁用' },
          { code: 2, codeName: '待开发' },
        ]
      },
    ]

    let onSubmit = this._addApplicationColumn.bind(this)

    let formProps = {
      ref: 'form',
      key: this.state.applicationId || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={applicationColumnLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { applicationColumn } = state;
  const addApplicationColumn = modelUtils.getModelEntity(applicationColumn, 'addApplicationColumn');
  const load = modelUtils.getLoadingState(state, 'applicationColumn');
  return {
    addApplicationColumn,
    ...load
  }
}

export default connect(mapStateToProps)(ApplicationColumnDetail);

